import { action } from 'typesafe-actions';
import { ACLResource } from '../ResourcesManagement/Types';
import {
	IUserCreationParams,
	IUserManagementActionTypes,
	IUserSearchParams,
	IUserSearchParamsSorting,
	Parent,
	UserACL,
	UserRights,
} from './Types';

export const addUserResourceRights = (
	token: string,
	userId: number,
	resourceId: number,
	rightsId: number[]
) =>
	action(IUserManagementActionTypes.ADD_USER_RESOURCE_RIGHTS, [
		token,
		userId,
		resourceId,
		rightsId,
	]);
export const addUserResourceRightsSucceed = () =>
	action(IUserManagementActionTypes.ADD_USER_RESOURCE_RIGHTS_SUCCEED);
export const addUserResourceRightsFailed = (err: string) =>
	action(IUserManagementActionTypes.ADD_USER_RESOURCE_RIGHTS_FAILED, [err]);

export const createACLUsers = (
	token: string,
	params: IUserCreationParams | null
) => action(IUserManagementActionTypes.CREATE_ACL_USERS, [token, params]);
export const createACLUsersFailed = (err: string) =>
	action(IUserManagementActionTypes.CREATE_ACL_USERS_FAILED, err);
export const createACLUsersSucceed = () =>
	action(IUserManagementActionTypes.CREATE_ACL_USERS_SUCCEED);

export const createMultipleACLUsers = (
	token: string,
	params: {
		dateCreation: string;
		dateCreationFormated: string;
		dateDebut: string;
		dateDebutFormated: string;
		email: string;
		emailError: boolean;
		emailErrorMsg: string;
		firstname: string;
		isActive: boolean;
		isGroup: boolean;
		language: string;
		lastname: string;
		localisation: string[];
		parentID: number;
		parentName: string;
		parentError: boolean;
		parentErrorMsg: string;
		password: string;
		phone: string;
		position: string;
		username: string;
		usernameError: boolean;
		usernameErrorMsg: string;
	}[]
) =>
	action(IUserManagementActionTypes.CREATE_MULTIPLE_ACL_USERS, [
		token,
		params,
	]);

export const createMultipleACLUsersFailed = (err: string) =>
	action(IUserManagementActionTypes.CREATE_MULTIPLE__ACL_USERS_FAILED, err);
export const createMultipleACLUsersSucceed = () =>
	action(IUserManagementActionTypes.CREATE_MULTIPLE__ACL_USERS_SUCCEED);

export const deleteUserResource = (token: string, id: number) =>
	action(IUserManagementActionTypes.DELETE_USER_RESOURCE, [token, id]);
export const deleteUserResourceFailed = (err: string) =>
	action(IUserManagementActionTypes.DELETE_USER_RESOURCE_FAILED, err);
export const deleteUserResourceSucceed = () =>
	action(IUserManagementActionTypes.DELETE_USER_RESOURCE_SUCEED);

export const emptyList = () => action(IUserManagementActionTypes.EMPTY_LIST);

export const emptyListUsernames = () =>
	action(IUserManagementActionTypes.EMPTY_LIST_USERNAMES);

export const emptyListRights = () =>
	action(IUserManagementActionTypes.EMPTY_LIST_RIGHTS);

export const getACLParents = (token: string, researchField: string) =>
	action(IUserManagementActionTypes.GET_ACL_PARENTS, [token, researchField]);
export const getACLParentsFailed = (err: string) =>
	action(IUserManagementActionTypes.GET_ACL_PARENTS_FAILED, err);
export const getACLParentsSucceed = (data: UserACL) =>
	action(IUserManagementActionTypes.GET_ACL_PARENTS_SUCCEED, data);

export const getACLUserByID = (token: string, params: number) =>
	action(IUserManagementActionTypes.GET_ACL_USER_BY_ID, [token, params]);
export const getACLUserByIDFailed = (err: string) =>
	action(IUserManagementActionTypes.GET_ACL_USER_BY_ID_FAILED, err);
export const getACLUserByIDSucceed = (data: UserACL) =>
	action(IUserManagementActionTypes.GET_ACL_USER_BY_ID_SUCCEED, data);

export const getACLUsers = (
	token: string,
	params: IUserSearchParams | null,
	paramsSorting: IUserSearchParamsSorting | null,
	resultsPerPage: number = 50,
	page: number = 0
) =>
	action(IUserManagementActionTypes.GET_ACL_USERS, [
		token,
		params,
		paramsSorting,
		resultsPerPage,
		page,
	]);
export const getACLUsersFailed = (err: string) =>
	action(IUserManagementActionTypes.GET_ACL_USERS_FAILED, err);
export const getACLUsersSucceed = (data: UserACL) =>
	action(IUserManagementActionTypes.GET_ACL_USERS_SUCCEED, data);

export const getAllACLUsernames = (token: string) =>
	action(IUserManagementActionTypes.GET_ALL_ACL_USERNAMES, [token]);
export const getAllACLUsernamesFailed = (err: string) =>
	action(IUserManagementActionTypes.GET_ALL_ACL_USERNAMES_FAILED, err);
export const getAllACLUsernamesSucceed = (
	allemail: string[],
	allusername: string[]
) =>
	action(IUserManagementActionTypes.GET_ALL_ACL_USERS_SUCCEED, [
		allemail,
		allusername,
	]);

export const getACLRights = (token: string) =>
	action(IUserManagementActionTypes.GET_ACL_RIGHTS, [token]);
export const getACLRightsFailed = (err: string) =>
	action(IUserManagementActionTypes.GET_ACL_RIGHTS_FAILED, err);
export const getACLRightsSucceed = (data: ACLResource[]) =>
	action(IUserManagementActionTypes.GET_ACL_RIGHTS_SUCCEED, data);

export const getUserRights = (token: string, id: number) =>
	action(IUserManagementActionTypes.GET_USER_RIGHTS, [token, id]);
export const getUserRigthsFailed = (err: string) =>
	action(IUserManagementActionTypes.GET_USER_RIGHTS_FAILED, err);
export const getUserRigthsSucceed = (data: UserRights) =>
	action(IUserManagementActionTypes.GET_USER_RIGHTS_SUCCEED, data);

export const impersonate = (token: string, userId: number) =>
	action(IUserManagementActionTypes.IMPERSONATE, [token, userId]);
export const impersonateFailed = (err: string) =>
	action(IUserManagementActionTypes.IMPERSONATE_FAILED, err);
export const impersonateSucceed = (token: string) =>
	action(IUserManagementActionTypes.IMPERSONATE_SUCCEED, token);

export const isUserAlreadyPresent = (token: string, username: string) =>
	action(IUserManagementActionTypes.IS_USER_ALREADY_PRESENT, [
		token,
		username,
	]);
export const isUserAlreadyPresentFailed = (err: string) =>
	action(IUserManagementActionTypes.IS_USER_ALREADY_PRESENT_FAILED, err);
export const isUserAlreadyPresentSucceed = (message: string) =>
	action(IUserManagementActionTypes.IS_USER_ALREADY_PRESENT_SUCCEED, message);

export const isLoading = (loading: boolean) =>
	action(IUserManagementActionTypes.IS_LOADING, loading);

export const modifyACLUserDateDebut = (
	token: string,
	id: number,
	newParams: string
) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_DATE_DEBUT, [
		token,
		id,
		newParams,
	]);
export const modifyACLUserDateDebutFailed = (err: string) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_DATE_DEBUT_FAILED, err);
export const modifyACLUserDateDebutSucceed = () =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_DATE_DEBUT_SUCCEED);

export const modifyACLUserDateExpire = (
	token: string,
	id: number,
	newParams: string
) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_DATE_EXPIRE, [
		token,
		id,
		newParams,
	]);
export const modifyACLUserDateExpireFailed = (err: string) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_DATE_EXPIRE_FAILED, err);
export const modifyACLUserDateExpireSucceed = () =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_DATE_EXPIRE_SUCCEED);

export const modifyACLUserEmail = (
	token: string,
	id: number,
	newParams: string
) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_EMAIL, [
		token,
		id,
		newParams,
	]);
export const modifyACLUserEmailFailed = (err: string) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_EMAIL_FAILED, err);
export const modifyACLUserEmailSucceed = () =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_EMAIL_SUCCEED);

export const modifyACLUserFirstname = (
	token: string,
	id: number,
	newParams: string
) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_FIRSTNAME, [
		token,
		id,
		newParams,
	]);
export const modifyACLUserFirstnameFailed = (err: string) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_FIRSTNAME_FAILED, err);
export const modifyACLUserFirstnameSucceed = () =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_FIRSTNAME_SUCCEED);

export const modifyACLUserIsActive = (
	token: string,
	id: number,
	newParams: boolean
) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_IS_ACTIVE, [
		token,
		id,
		newParams,
	]);
export const modifyACLUserIsActiveFailed = (err: string) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_IS_ACTIVE_FAILED, err);
export const modifyACLUserIsActiveSucceed = (userId: number, isActive: boolean) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_IS_ACTIVE_SUCCEED, isActive, { userId });

export const modifyACLUserLanguage = (
	token: string,
	id: number,
	newParams: string
) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_LANGUAGE, [
		token,
		id,
		newParams,
	]);
export const modifyACLUserLanguageFailed = (err: string) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_LANGUAGE_FAILED, err);
export const modifyACLUserLanguageSucceed = () =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_LANGUAGE_SUCCEED);

export const modifyACLUserLocalisation = (
	token: string,
	id: number,
	newParams: string[]
) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_LOCALISATION, [
		token,
		id,
		newParams,
	]);
export const modifyACLUserLocalisationFailed = (err: string) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_LOCALISATION_FAILED, err);
export const modifyACLUserLocalisationSucceed = () =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_LOCALISATION_SUCCEED);

export const modifyACLUserName = (
	token: string,
	id: number,
	newParams: string
) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_NAME, [
		token,
		id,
		newParams,
	]);
export const modifyACLUserNameFailed = (err: string) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_NAME_FAILED, err);
export const modifyACLUserNameSucceed = () =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_NAME_SUCCEED);

export const modifyACLUserParent = (
	token: string,
	id: number,
	newParams: number
) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_PARENT, [
		token,
		id,
		newParams,
	]);
export const modifyACLUserParentFailed = (err: string) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_PARENT_FAILED, err);
export const modifyACLUserParentSucceed = () =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_PARENT_SUCCEED);

export const modifyACLUserPosition = (
	token: string,
	id: number,
	newParams: string
) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_POSITION, [
		token,
		id,
		newParams,
	]);
export const modifyACLUserPositionFailed = (err: string) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_POSITION_FAILED, err);
export const modifyACLUserPositionSucceed = () =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_POSITION_SUCCEED);

export const modifyACLUserPhone = (
	token: string,
	id: number,
	newParams: string
) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_PHONE, [
		token,
		id,
		newParams,
	]);
export const modifyACLUserPhoneFailed = (err: string) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_PHONE_FAILED, err);
export const modifyACLUserPhoneSucceed = () =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_PHONE_SUCCEED);

export const modifyACLUserUsername = (
	token: string,
	id: number,
	newParams: string
) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_USERNAME, [
		token,
		id,
		newParams,
	]);
export const modifyACLUserUsernameFailed = (err: string) =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_USERNAME_FAILED, err);
export const modifyACLUserUsernameSucceed = () =>
	action(IUserManagementActionTypes.MODIFY_ACL_USER_USERNAME_SUCCEED);

export const setLastParams = (params: IUserSearchParams) =>
	action(IUserManagementActionTypes.SET_LAST_PARAMS, params);

export const updateUserResourceRights = (
	token: string,
	resourceId: number,
	rightsId: number[]
) =>
	action(IUserManagementActionTypes.UPDATE_USER_RESOURCE_RIGHTS, [
		token,
		resourceId,
		rightsId,
	]);
export const updateUserResourceRightsSucceed = () =>
	action(IUserManagementActionTypes.UPDATE_USER_RESOURCE_RIGHTS_SUCCEED);
export const updateUserResourceRightsFailed = (err: string) =>
	action(IUserManagementActionTypes.UPDATE_USER_RESOURCE_RIGHTS_FAILED, [
		err,
	]);
export const updateACLUserModifiedName = (data: string) =>
	action(IUserManagementActionTypes.UPDATE_ACL_USER_MODIFIED_NAME, data);
export const updateACLUserModifiedFirstname = (data: string) =>
	action(IUserManagementActionTypes.UPDATE_ACL_USER_MODIFIED_FIRSTNAME, data);
export const updateACLUserModifiedUsername = (data: string) =>
	action(IUserManagementActionTypes.UPDATE_ACL_USER_MODIFIED_USERNAME, data);
export const updateACLUserModifiedEmail = (data: string) =>
	action(IUserManagementActionTypes.UPDATE_ACL_USER_MODIFIED_EMAIL, data);
export const updateACLUserModifiedParent = (data: Parent) =>
	action(IUserManagementActionTypes.UPDATE_ACL_USER_MODIFIED_PARENT, data);
export const updateACLUserModifiedPhoneNumber = (data: string) =>
	action(
		IUserManagementActionTypes.UPDATE_ACL_USER_MODIFIED_PHONE_NUMBER,
		data
	);
export const updateACLUserModifiedPosition = (data: string) =>
	action(IUserManagementActionTypes.UPDATE_ACL_USER_MODIFIED_POSITION, data);
export const updateACLUserModifiedLocalisation = (data: string[]) =>
	action(
		IUserManagementActionTypes.UPDATE_ACL_USER_MODIFIED_LOCALISATION,
		data
	);
export const updateACLUserModifiedLanguage = (data: string) =>
	action(IUserManagementActionTypes.UPDATE_ACL_USER_MODIFIED_LANGUAGE, data);
export const updateACLUserModifiedStartDate = (data: string) =>
	action(
		IUserManagementActionTypes.UPDATE_ACL_USER_MODIFIED_START_DATE,
		data
	);
export const updateACLUserModifiedEndDate = (data: string) =>
	action(IUserManagementActionTypes.UPDATE_ACL_USER_MODIFIED_END_DATE, data);
export const updateACLUserModifiedUserActive = (data: boolean) =>
	action(
		IUserManagementActionTypes.UPDATE_ACL_USER_MODIFIED_USER_ACTIVE,
		data
	);

export const updateRightsBatch = (
	token: string,
	userId: number,
	addedRights: { resourceId: number; rightsId: number[] }[],
	resourceIDsRightsToBeDeleted: number[],
	resourceIDsRightsToBeUpdated: { usersResourcesID: number; rightsId: number[] }[]
) =>
	action(IUserManagementActionTypes.UPDATE_RIGHTS_BATCH, {
		token,
		userId,
		addedRights,
		resourceIDsRightsToBeDeleted,
		resourceIDsRightsToBeUpdated
	});

export const updateRightsBatchSuccess = () =>
	action(IUserManagementActionTypes.UPDATE_RIGHTS_BATCH_SUCCESS);

export const updateRightsBatchFailure = (error: Error) =>
	action(IUserManagementActionTypes.UPDATE_RIGHTS_BATCH_FAILURE, error);

export const setRightsLoading = (loading: boolean) =>
	action(IUserManagementActionTypes.SET_RIGHTS_LOADING, loading);
